module.exports = __webpack_public_path__ + "static/media/success_svg.716a997f.svg";